/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react'

import {
  Typography,
  Switch,
  Dialog,
  Select,
  MenuItem,
  IconButton,
  Menu,
  Button,
  InputBase,
  Grid,
  Paper,
  Tooltip,
} from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import MoreVertIcon from '@material-ui/icons/MoreVert'

import useStyles from './cardActivation.styles'
import { CheckGreen, XRed, ChevronUp, ChevronDown, MoreInfo } from './icon'

import BackDrop from 'components/BackDrop'
import { SearchIcon } from 'components/icons/personalizedIcons'
import ManagementInfo from 'components/ManagementInfo/ManagementInfo'
import PaginationBusiness from 'components/PaginationBusiness/PaginationBusiness'
import RejectAndDeactivationManagement from 'components/RejectionManagement/RejectAndDeactivationManagement'
import SkeletonTable from 'components/SkeletonTable/SkeletonTable'
import {
  BUSINESSES_DISABLED,
  BUSINESSES_PENDING,
  BUSINESSES_ACTIVATED,
  BUSINESSES_REFUSED,
  MODAL_INFO,
  MODAL_INPUT,
  TITLE_BUTTON_REJECT,
  TITLE_BUTTON_DEACTIVATION,
  IMAGE_DEFAULD,
} from 'constants/Businesses'
import useActivationBlock from 'hook/useActivationBlock'
import {
  getBusinessesStatus,
  putStatusManagement,
  getplans,
  patchchangePlan,
  getBusinesses,
} from 'services/businesses/businesses.services'

const businessesToRemove = [3, 4, 7]

function CatalogStatusControls({
  status,
  ally,
  business,
  classes,
  updateAllies,
  setShowModal,
  setPendingUpdate,
  setTypeModal,
}) {
  const { isActivationBlocked, tooltipMessage } = useActivationBlock({ status, ally, business })

  if (status === BUSINESSES_DISABLED || status === BUSINESSES_ACTIVATED) {
    const switchControl = (
      <Switch
        checked={status !== BUSINESSES_DISABLED}
        disabled={isActivationBlocked}
        onChange={(event) => {
          if (isActivationBlocked) return
          if (event.target.checked) {
            updateAllies(ally.storeId, business.businessId, BUSINESSES_ACTIVATED, null, null, {
              keepModalOpen: true,
              silentRefresh: true,
            })
          } else {
            setShowModal(true)
            setPendingUpdate({
              storeId: ally.storeId,
              businessId: business.businessId,
              statusId: BUSINESSES_DISABLED,
            })
            setTypeModal({
              title: 'Gestión de desactivación',
              type: MODAL_INPUT,
              titleButton: TITLE_BUTTON_DEACTIVATION,
            })
          }
        }}
        color="primary"
        name="isActive"
      />
    )

    let moreInfoControl = null
    if (status === BUSINESSES_DISABLED) {
      if (isActivationBlocked && tooltipMessage) {
        moreInfoControl = (
          <Tooltip title={tooltipMessage} classes={{ tooltip: classes.bigTooltip }} placement="top">
            <span>
              <button type="button">
                <MoreInfo />
              </button>
            </span>
          </Tooltip>
        )
      } else {
        moreInfoControl = (
          <button
            type="button"
            onClick={() => {
              setTypeModal({
                title: 'Gestión de desactivación',
                type: MODAL_INFO,
                body: business.deactiveReason,
                titleButton: '',
                daysRemaining: business.daysRemaining ?? 0,
              })
              setShowModal(true)
            }}
          >
            <MoreInfo />
          </button>
        )
      }
    }

    return (
      <div className={classes.moreInfo}>
        {switchControl}
        {moreInfoControl}
      </div>
    )
  }

  if (status === BUSINESSES_REFUSED) {
    const daysRemaining = business.daysRemaining ?? 0
    return (
      <div className={classes.moreInfo}>
        <div>
          <div className={classes.rejectedNote}>{`Resta: ${daysRemaining} días`}</div>
        </div>
        <button
          type="button"
          onClick={() => {
            setTypeModal({
              title: 'Gestión del rechazo',
              type: MODAL_INFO,
              body: business.rejectionReason,
              titleButton: '',
              daysRemaining,
            })
            setShowModal(true)
          }}
        >
          <MoreInfo />
        </button>
      </div>
    )
  }

  if (status === BUSINESSES_PENDING) {
    return (
      <div className={classes.buttonCheck}>
        <Tooltip
          title={isActivationBlocked ? tooltipMessage : ''}
          classes={{ tooltip: classes.bigTooltip }}
          placement="top"
          disableHoverListener={!isActivationBlocked}
        >
          <span>
            <button
              type="button"
              disabled={isActivationBlocked}
              className={`${classes.actionButton} ${
                isActivationBlocked ? classes.disabledActionButton : ''
              }`}
              onClick={() =>
                updateAllies(ally.storeId, business.businessId, BUSINESSES_ACTIVATED, null, null, {
                  keepModalOpen: true,
                  silentRefresh: true,
                })
              }
            >
              <CheckGreen />
            </button>
          </span>
        </Tooltip>
        <button
          type="button"
          className={classes.actionButton}
          onClick={() => {
            setPendingUpdate({
              storeId: ally.storeId,
              businessId: business.businessId,
              statusId: BUSINESSES_REFUSED,
            })
            setTypeModal({
              title: 'Gestión del rechazo',
              type: MODAL_INPUT,
              titleButton: TITLE_BUTTON_REJECT,
            })
            setShowModal(true)
          }}
        >
          <XRed />
        </button>
      </div>
    )
  }

  return null
}

export default function CardActivation() {
  const classes = useStyles()
  const [businesses, setBusinesses] = useState([])
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
  })
  const [loading, setLoading] = useState(false)
  const [showSkeleton, setShowSkeleton] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [pendingUpdate, setPendingUpdate] = useState(null)
  const [typeModal, setTypeModal] = useState({ title: '', type: 0, titleButton: '' })
  const [openIndex, setOpenIndex] = useState(null)
  const [bundles, setBundles] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [openModalManagementIncome, setOpenModalManagementIncome] = useState(false)
  const [selectedStoreBusinesses, setSelectedStoreBusinesses] = useState(null)
  const [businessesMercurio, setBusinessesMercurio] = useState(null)
  const [open, setOpen] = useState(false)
  const [selectedAlly, setSelectedAlly] = useState(null)
  const [filterText, setFilterText] = useState('')
  const [committedSearch, setCommittedSearch] = useState('')
  const optionsMenu = [{ name: 'Gestión de negocios' }]
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i)
  const headerTable = [
    { name: 'Nombre del seller' },
    { name: 'Modulo(s) o combo' },
    { name: 'Caracteriatica' },
    { name: 'Estado' },
    { name: 'Acciones' },
  ]

  const updateLocalBusinessStatus = (
    storeId,
    businessId,
    statusId,
    rejectionReason = null,
    deactivationReason = null
  ) => {
    setBusinesses((prev) =>
      prev.map((ally) => {
        if (ally.storeId !== storeId) return ally
        const storeBusinesses = ally.storeBusinesses.map((sb) =>
          sb.businessId === businessId
            ? { ...sb, statusId, rejectionReason, deactiveReason: deactivationReason }
            : sb
        )
        return { ...ally, storeBusinesses }
      })
    )
    setSelectedStoreBusinesses((prev) => {
      if (!prev || prev.storeId !== storeId) return prev
      const storeBusinesses = prev.storeBusinesses.map((sb) =>
        sb.businessId === businessId
          ? { ...sb, statusId, rejectionReason, deactiveReason: deactivationReason }
          : sb
      )
      return { ...prev, storeBusinesses }
    })
  }

  const getMercuryAllies = (
    page = '1',
    pageSize = '10',
    search = committedSearch,
    { silent = false } = {}
  ) => {
    if (!silent) setShowSkeleton(true)
    setOpenIndex(null)
    getBusinessesStatus(page, pageSize, search)
      .then((response) => {
        const datagetBusinesses = response.data.data
        const { data } = datagetBusinesses
        const businessType = data
          .map((business) => ({
            ...business,
            storeBusinesses: business.storeBusinesses.filter(
              (storeBusiness) => !businessesToRemove.includes(storeBusiness.businessId)
            ),
          }))
          .filter((business) => business.storeBusinesses.length > 0)
        setPagination({
          page: datagetBusinesses.page,
          pageSize: datagetBusinesses.pageSize,
          totalItems: datagetBusinesses.totalItems,
          totalPages: datagetBusinesses.totalPages,
        })
        setBusinesses(businessType)
        if (!silent) setShowSkeleton(false)
      })
      .catch(() => {
        if (!silent) setShowSkeleton(false)
      })
  }

  const handleClearSearch = () => {
    setFilterText('')
    setCommittedSearch('')
    getMercuryAllies(1, 10, '')
  }

  const updateAllies = (
    storeId,
    businessId,
    statusId,
    rejectionReason,
    deactivationReason,
    { keepModalOpen = true, silentRefresh = true } = {}
  ) => {
    setLoading(true)
    putStatusManagement(storeId, businessId, statusId, rejectionReason, deactivationReason)
      .then((response) => {
        if (response.status === 200) {
          updateLocalBusinessStatus(
            storeId,
            businessId,
            statusId,
            rejectionReason,
            deactivationReason
          )
          if (!keepModalOpen) {
            setOpenModalManagementIncome(false)
            setSelectedStoreBusinesses(null)
          }
          if (silentRefresh) {
            getMercuryAllies(pagination.page, pagination.pageSize, committedSearch, {
              silent: true,
            })
          }
        }
        setPendingUpdate(null)
        setTypeModal({ title: '', type: 0, titleButton: '' })
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const getPlansSellers = () => {
    getplans().then((response) => {
      setBundles(response.data.data)
    })
  }

  const getBusinessesMercurio = () => {
    getBusinesses()
      .then((response) => {
        const data = response.data.data.filter(
          (business) => !businessesToRemove.includes(business.id)
        )
        setBusinessesMercurio(data)
      })
      .catch(() => {})
  }

  useEffect(() => {
    getMercuryAllies()
    getPlansSellers()
    getBusinessesMercurio()
  }, [])

  const handleCancelClick = () => {
    setShowModal(false)
    setTypeModal({ title: '', type: 0, titleButton: '' })
  }

  const handleRejectClick = (text) => {
    let rejectionReason = null
    let deactivationReason = null
    if (typeModal.titleButton === TITLE_BUTTON_REJECT) {
      rejectionReason = text
    }
    if (typeModal.titleButton === TITLE_BUTTON_DEACTIVATION) {
      deactivationReason = text
    }
    if (!pendingUpdate) return
    const { storeId, businessId, statusId } = pendingUpdate
    setShowModal(false)
    updateAllies(storeId, businessId, statusId, rejectionReason, deactivationReason, {
      keepModalOpen: true,
      silentRefresh: true,
    })
  }

  const changePlan = (id, credinetStoreIds) => {
    patchchangePlan(id, credinetStoreIds).then(() => {
      getMercuryAllies(pagination.page, pagination.pageSize, committedSearch)
    })
  }

  return (
    <>
      <Dialog
        disableEscapeKeyDown
        fullWidth
        open={showModal}
        classes={{ paper: classes.dialogPaper }}
      >
        {typeModal.type === MODAL_INPUT && (
          <RejectAndDeactivationManagement
            title={typeModal.title}
            titleButton={typeModal.titleButton}
            handleCancelClick={() => handleCancelClick()}
            handleRejectClick={(text) => handleRejectClick(text)}
          />
        )}
        {typeModal.type === MODAL_INFO && (
          <ManagementInfo
            title={typeModal.title}
            body={typeModal.body}
            daysRemaining={typeModal.daysRemaining}
            onClose={() => handleCancelClick()}
          />
        )}
      </Dialog>
      <Dialog
        disableEscapeKeyDown
        fullWidth
        open={openModalManagementIncome}
        classes={{ paper: classes.dialogPaper }}
      >
        <>
          {businessesMercurio &&
            businessesMercurio.map((item) => {
              const business = selectedStoreBusinesses?.storeBusinesses.find(
                (sb) => sb.businessId === item.id
              )
              if (!business) return null
              return (
                <div key={item.id} className={classes.row}>
                  <div className={classes.iconAndLabel}>
                    <span className={classes.icon}>
                      <img src={item.iconUrl || IMAGE_DEFAULD} alt="catalogo" />
                    </span>
                    <span>{item.name}</span>
                  </div>
                  <div className={classes.status}>
                    <CatalogStatusControls
                      status={business.statusId}
                      ally={selectedStoreBusinesses}
                      business={business}
                      classes={classes}
                      updateAllies={updateAllies}
                      setShowModal={setShowModal}
                      setPendingUpdate={setPendingUpdate}
                      setTypeModal={setTypeModal}
                    />
                  </div>
                </div>
              )
            })}
          <div>
            <Button
              className={classes.buttonOutlined}
              onClick={() => {
                setSelectedStoreBusinesses(null)
                setOpenModalManagementIncome(false)
              }}
            >
              Cancelar
            </Button>
          </div>
        </>
      </Dialog>
      <Typography variant="h6" style={{ color: '#6064FF', marginBottom: 10 }}>
        Gestión de Negocio
      </Typography>
      <Grid item>
        <Paper className={classes.root}>
          <InputBase
            className={classes.input}
            placeholder="Busca Aliado por nombre de tienda o nit"
            value={filterText}
            onChange={(e) => {
              const v = e.target.value
              setFilterText(v)
              if (v.trim() === '') {
                setCommittedSearch('')
                getMercuryAllies(1, 10, '')
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                setCommittedSearch(filterText)
                getMercuryAllies(1, 10, filterText)
              } else if (e.key === 'Escape') {
                handleClearSearch()
              }
            }}
          />
          <IconButton
            className={classes.iconButton}
            aria-label="search"
            onClick={() => {
              if (filterText.trim() === '') return
              setCommittedSearch(filterText)
              getMercuryAllies(1, 10, filterText)
            }}
          >
            <SearchIcon />
          </IconButton>
          {filterText !== '' && (
            <Tooltip title="Limpiar">
              <IconButton
                className={classes.iconButton}
                aria-label="clear"
                onClick={handleClearSearch}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}
        </Paper>
      </Grid>

      <BackDrop open={loading} />
      {!showSkeleton && (
        <div className={classes.tableWrapper}>
          <table className={classes.table}>
            <thead className={classes.thead}>
              <tr>
                {headerTable.map((header) => {
                  return (
                    <th key={header.name} className={classes.th}>
                      <div className={classes.cardLogoText}>
                        <p className={classes.title}>{header.name}</p>
                      </div>
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {businesses.length ? (
                businesses.map((ally, index) => {
                  return (
                    <tr key={index} className={classes.trStyles}>
                      <td
                        className={`${classes.td} ${classes.characteristics}`}
                        style={{ textAlign: 'left' }}
                      >
                        <p style={{ fontWeight: 'bold' }}>{ally.name}</p>
                        <p style={{ fontSize: '12px' }}> {`NIT: ${ally.nit}`}</p>
                      </td>
                      <td className={`${classes.td} ${classes.catalogCell}`}>
                        <Select
                          name="selectedSupplier"
                          value={bundles.find((bundle) => bundle.id === ally.planId)}
                          className={classes.select}
                          variant="outlined"
                          onChange={(event) => {
                            const { value } = event.target
                            changePlan(value.id, ally.storeId)
                          }}
                        >
                          {bundles.map((supplier) => (
                            <MenuItem
                              key={supplier.id}
                              value={supplier}
                              className={classes.menuItem}
                            >
                              {supplier.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </td>
                      <td
                        className={`${classes.td} ${classes.catalogCell} ${classes.characteristics}`}
                      >
                        {(() => {
                          const bundle = bundles.find((b) => b.id === ally.planId)
                          return bundle && <div>{bundle.description}</div>
                        })()}
                      </td>
                      <td className={`${classes.td} ${classes.catalogCell}`}>Activo</td>
                      <td className={`${classes.td} ${classes.catalogCell} ${classes.position}`}>
                        <div>
                          <IconButton
                            className={classes.iconEye}
                            onClick={(event) => {
                              setAnchorEl(event.currentTarget)
                              setOpen(true)
                              setSelectedAlly(ally)
                            }}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            keepMounted
                            open={open}
                            onClose={() => {
                              setOpen(false)
                              setAnchorEl(null)
                            }}
                            PaperProps={{
                              style: {
                                minWidth: '200px',
                                width: 'auto',
                                boxShadow: '-6px 6px #E8E8E8',
                                fontFamily: 'Red Hat Display Regular',
                                left: 'auto',
                                right: 'auto',
                                marginTop: '10px',
                                marginRight: '80px',
                              },
                            }}
                          >
                            {optionsMenu &&
                              optionsMenu.map((option) => (
                                <MenuItem
                                  key={option.name}
                                  onClick={() => {
                                    setOpenModalManagementIncome(true)
                                    setSelectedStoreBusinesses(selectedAlly)
                                    setOpen(false)
                                  }}
                                  style={{
                                    fontFamily: 'Red Hat Display Regular',
                                    whiteSpace: 'nowrap',
                                    padding: '8px 16px',
                                    minWidth: '200px',
                                  }}
                                >
                                  {option.name}
                                </MenuItem>
                              ))}
                          </Menu>
                        </div>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr className={classes.trStyles}>
                  <td colSpan={5} className={classes.tdNoData}>
                    No se encontraron resultados
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <SkeletonTable isLoading={showSkeleton} />
      {!showSkeleton && (
        <div className={classes.mobileOnly}>
          {businesses &&
            businesses.map((ally, i) => {
              return (
                <div key={i} className={classes.card}>
                  <div
                    className={`${classes.headerContainer} ${
                      openIndex === i ? classes.activeHeader : ''
                    }`}
                  >
                    <button
                      type="button"
                      className={classes.headerButton}
                      onClick={() => toggle(i)}
                    >
                      <div className={classes.headerContent}>
                        <div>{ally.name}</div>
                        <div className={classes.headerActions}>
                          <IconButton
                            className={classes.iconEye}
                            onClick={(event) => {
                              event.stopPropagation()
                              setAnchorEl(event.currentTarget)
                              setOpen(true)
                              setSelectedAlly(ally)
                            }}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          {openIndex === i ? <ChevronUp /> : <ChevronDown />}
                        </div>
                      </div>
                    </button>
                  </div>

                  {openIndex === i && (
                    <>
                      <tr className={classes.trStyles}>
                        <td className={`${classes.td} ${classes.catalogCell}`}>
                          <Select
                            name="selectedSupplier"
                            value={bundles.find((bundle) => bundle.id === ally.planId)}
                            className={classes.select}
                            variant="outlined"
                            onChange={(event) => {
                              const { value } = event.target
                              changePlan(value.id, ally.storeId)
                            }}
                          >
                            {bundles.map((supplier) => (
                              <MenuItem key={supplier.id} value={supplier}>
                                {supplier.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </td>
                        <td className={`${classes.td} ${classes.catalogCell}`}>
                          {(() => {
                            const bundle = bundles.find((b) => b.id === ally.planId)
                            return bundle && <div>{bundle.description}</div>
                          })()}
                        </td>
                        <td className={`${classes.td} ${classes.catalogCell}`}>Activo</td>
                      </tr>
                    </>
                  )}
                </div>
              )
            })}
        </div>
      )}
      {!showSkeleton && (
        <div className={classes.paginationBusiness}>
          <PaginationBusiness
            page={pagination.page}
            totalPages={pagination.totalPages}
            onPageChange={(page, pageSize) => getMercuryAllies(page, pageSize, committedSearch)}
          />
        </div>
      )}
    </>
  )
}
